import React from "react";
import { RadioGroup } from "@material-ui/core";

export const FormikRadioGroup = ({
  field,
  form: { touched, errors },
  name,
  options,
  children,
  ...props
}:any) => {
  const fieldName = name || field.name;
  return (
    <React.Fragment>
      <RadioGroup {...field} {...props} name={fieldName}>
        {children}
      </RadioGroup>

      {touched[fieldName] && errors[fieldName] && (
        <span style={{ color: "red", fontFamily: "sans-serif" }}>
          {errors[fieldName]}
        </span>
      )}
    </React.Fragment>
  );
};
